import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../../components/Loader';
import { selectWorks } from '../../../Api/selectors';
import { changeWebsiteUserFilter, fetchWebsiteUsers } from '../../actions';
import { REQUEST_WEBSITE_USERS } from '../../constants';
import {
  selectWebsiteUserCount, selectWebsiteUserFilter,
  selectWebsiteUserPaginator,
  selectWebsiteUsers
} from '../../selectors';
import { HBox, VBox } from '../../../../components/Box';
import { ChevronRight } from '../../../../components/Icon';
import { UserSearch } from '../../components/Search';
import { PageHeader } from '../../../../components/PageHeader';
import { COLOR_TABLE_HEADER } from '../../../../vars';
import { Checkbox } from '../../../../components/Checkbox';
import { Sort } from '../../../../components/Sort';
import { KanbanProgressBar } from '../../../KanbanBoards/components/ProgressBar';
import { Pagination } from '../../../../components/Pagination';
import { setScrollPosition } from '../../../Actions/actions';
import { WebsiteUsersMainFilterSection } from "./websiteUsersMainFilterSection";

const Container = styled.div`


font-size: 12px;
  .filters {
    padding: 24px;
    background-color: white;
    margin-bottom: 22px;
  }

  .rows {
    .check-col {
      min-width: 40px;
      text-align: center;
    }
    background-color: white;
    .header {
      background-color: ${COLOR_TABLE_HEADER};
      .box {
        height: 52px;
        white-space: nowrap;
        flex-shrink: 0;
        > div {
          font-weight: 600;
        }
      }
    }

    .header-col {
      width: auto;
      width: 120px;
      overflow: hidden;

      text-transform: capitalize;

      &.col-info {
        justify-content: center;
      }
    }

    .item-cell {
      padding: 4px;
      width: 120px;

      &:last-child {
        justify-content: flex-end;
      }
    }

    .col-check {
      text-align: center;
      width: 40px;
    }

    .col-name {
      font-weight: bold;
      padding: 16px 0;
      width: 200px;
    }

    .col-surname {
      width: 150px;
    }

    .col-email_address {
      width: 300px;
    }

    .item-row {
      border-bottom: 1px solid ${COLOR_TABLE_HEADER};
    }
  }
`;

const STATE = {
  isOpen: false,
  currentPage: 0,
};

/* eslint-disable react/prefer-stateless-function */
class WebsiteUsersOverviewComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  cols() {
    return ['name', 'surname', 'email_address'];
  }

  selectPage = newPage => {
    if (newPage === this.state.currentPage) return;
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);
    this.setState({ currentPage: newPage }, this.props.changeFilter('offset', newOffset));
  };

  handleClick = (event, itemId) => {
    this.props.setScrollPosition(`#item${itemId}`);
    this.to(`/website-users/${itemId}`, event?.ctrlKey || event?.metaKey);
  };
  renderRow(user) {
    return (
      <HBox
        className="item-row"
        vCenter
        left
        key={user.id}
        id={`item${user.id}`}
        onClick={event => this.handleClick(event, user.id)}
      >
        <div className="col-check">
          <Checkbox />
        </div>
        {this.cols().map(col => this.renderCell(col, user))}
      </HBox>
    );
  }

  renderHeaderCell(col) {
    switch (col) {
      default:
        return this.lbl(`users.overview.column.${col}`);
    }
  }

  renderCell(col, user) {
    const fn = () => {
      switch (col) {
        case 'name':
          return (
            <>
              {user.name}&nbsp;{user.surname}
              <br />
              {/* <KanbanProgressBar type="user" target={user} /> */}
            </>
          );
        default:
          return user[col];
      }
    };

    return (
      <div className={`item-cell col-${col}`} key={`${col}-${user.id}`}>
        {fn()}
      </div>
    );
  }

  renderCard = (user, idx) => {
    return (
      <VBox
        vCenter
        left
        key={user.id ?? `user${idx}`}
        id={`item${user.id}`}
        onClick={() => this.handleClick(user.id)}
        style={{ margin: '10px 0' }}
      >
        <HBox vCenter style={{ padding: 10, borderBottom: '1px solid #eee' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox />
            <span style={{ textAlign: 'left' }}>
              <strong>{user?.name ?? 'Unknown Name'}</strong> {user?.surname ?? 'Unknown Surname'}
            </span>
          </div>
          {/*<div style={{ backgroundColor: "black", color: 'white', padding: 2 }}>{user.status ?? '-'}</div>*/}
        </HBox>
        <VBox style={{ padding: '12px', borderBottom: '1px solid #eee', width: '100%', gap: 10 }}>
          <div>{user.email_address}</div>
          <KanbanProgressBar type="user" target={user} />
        </VBox>
      </VBox>
    );
  };

  onSelectMainFilter(filterName) {
    this.props.changeFilter('mainFilter', filterName)
  }

  get selectedMainFilter() {
    return this.props?.filter?.mainFilter ?? null;
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <PageHeader
          title={
            <>
              {this.lbl('leftBar.website_users')} <span className="label number">{this.props.count}</span>
            </>
          }
          breadCrumbs={
            <>
              <a href="/">Vindat</a>
              <ChevronRight />
              {this.lbl('leftBar.website_users')}
            </>
          }
        />
        <div className="filters">
          <HBox left vBottom>
            <UserSearch />
          </HBox>
        </div>
        <WebsiteUsersMainFilterSection selected={this.selectedMainFilter} onSelect={this.onSelectMainFilter.bind(this)} />

        {window.innerWidth <= 768 ? (
          this.props?.users?.filter(v => v).map((user, idx) => <div className="rows">{this.renderCard(user, idx)}</div>)
        ) : (
          <div className="rows">
            <div className="header">
              <HBox vCenter left>
                <div className="check-col">
                  <Checkbox />
                </div>
                {this.cols().map((col, index) => (
                  <HBox
                    className={`header-col col-${col}`}
                    vCenter
                    left
                    key={`${col}-${index}`}
                    onClick={() => this.sortOn(col)}
                  >
                    {this.renderHeaderCell(col)}
                    <Sort direction={this.state.sort == col ? this.state.sort_direction : 'none'} />
                  </HBox>
                ))}
              </HBox>
            </div>
            {this.props.users.filter(v => v).map(user => this.renderRow(user))}
          </div>
        )}
        {!!this.props.users?.length && this.props.paginator?.itemsCount > this.props.paginator?.limit && (
          <Pagination paginator={this.props.paginator} selectPage={this.selectPage} />
        )}
      </Container>
    );
  }
}

WebsiteUsersOverviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    users: selectWebsiteUsers(),
    count: selectWebsiteUserCount(),
    paginator: selectWebsiteUserPaginator(),
    work: selectWorks([REQUEST_WEBSITE_USERS]),
    filter: selectWebsiteUserFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(fetchWebsiteUsers());
    },
    changeFilter(key, value) {
      dispatch(changeWebsiteUserFilter(key, value));
    },
    setScrollPosition(elemId) {
      dispatch(setScrollPosition(elemId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WebsiteUsersOverview = compose(withConnect, withRouter)(WebsiteUsersOverviewComp);
